import { FC } from "react";
import { Banner, Stack, Text, List } from "@shopify/polaris";

interface ValidationErrorsListBannerProps {
    errors: string[];
    show: boolean;
}

const ValidationErrorsListBanner: FC<ValidationErrorsListBannerProps> = ({ errors, show }) => {
    if (!show || !errors.length) return null;

    const uniqueErrors = Array.from(new Set(errors));
    const errorText =
        uniqueErrors.length === 1
            ? "There is 1 error in this step:"
            : `There are errors in this step:`;

    return (
        <Banner status="critical">
            <Stack vertical spacing="tight">
                <Text as="p" variant="bodyMd" fontWeight="bold">
                    {errorText}
                </Text>
                <List type="bullet">
                    {uniqueErrors.map((error, index) => (
                        <List.Item key={index}>
                            <Text as="p" variant="bodyMd">
                                {error}
                            </Text>
                        </List.Item>
                    ))}
                </List>
            </Stack>
        </Banner>
    );
};

export default ValidationErrorsListBanner;
